module.exports = __webpack_public_path__ + "img/loan_history.52203199.png";